module.exports = __webpack_public_path__ + "static/media/orcEnemy.dbc837fe.jpg";